import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=0c374b96"
import script from "./OrdersReport.vue?vue&type=script&lang=ts"
export * from "./OrdersReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports